import { UserSelectionInformation } from "../../../domain/user";
import { IUserSelectionBean } from "./beans";

export class UserSelectionInformationTranslator {
  toUserSelectionInformation(bean: IUserSelectionBean): UserSelectionInformation {
    if (!bean) { return null; }
    const info = new UserSelectionInformation();
    info.fixedPhraseDragAndDropMode = bean.fixedPhraseDragAndDropMode;
    return info;
  }

  toUserSelectionBean(info: UserSelectionInformation): IUserSelectionBean {
    if (!info) { return null; }
    return {
      fixedPhraseDragAndDropMode: info.fixedPhraseDragAndDropMode,
    };
  }
}
